import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, TokenSource } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

export const AdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);

  if (!authService.getAccessToken()) {
    notificationService.showError('Authentication required');
    router.navigate(['/login']);
    return false;
  }

  // Original token — admin must keep admin access while impersonating another user.
  if (authService.hasClientRole('admin', TokenSource.Original)) return true;

  notificationService.showError('Admin access required');
  router.navigate(['/agents']);
  return false;
};
